<template>
    <div class="setpaypwd-page">
        <header class="top-nav">
            <button type="button" class="back-btn" @click="$router.back()">
                <van-icon name="arrow-left" />
            </button>
            <div class="nav-title">{{ $t('setpaypwd.modifyPaymentPassword') }}</div>
        </header>

        <main class="page-content">
            <section class="form-card">
                <div class="card-header">
                    <div>
                        <h1>{{ $t('setpaypwd.setNewPaymentPassword') }}</h1>
                        <p>{{ getLabel('pageSetpaypwd.modeHint', '支付密码仅支持 6 位数字，请妥善保管，不要与其他密码混用。') }}</p>
                    </div>
                    <button
                        v-if="!codeStatus"
                        type="button"
                        class="switch-mode"
                        @click="cutType(1)"
                    >
                        {{ $t('setpwd.usemobilenumber') }}
                    </button>
                </div>

                <div v-if="codeStatus" class="section-block">
                    <label class="field-label">{{ $t('setpwd.boundmobilenumber') }}</label>
                    <div class="info-box">{{ ycmobile || '--' }}</div>

                    <label class="field-label">{{ $t('setpwd.SMSverificationcode') }}</label>
                    <div class="code-wrap">
                        <input
                            v-model.trim="code"
                            type="text"
                            class="text-input"
                            :placeholder="$t('setpwd.SMSverificationcode')"
                        >
                        <van-count-down :time="time" class="countdown" @finish="timeCall">
                            <template v-slot="timeData">
                                <button
                                    type="button"
                                    class="code-btn"
                                    :disabled="timeData.seconds > 0 || is_send"
                                    @click="sendcode"
                                >
                                    {{ timeData.seconds > 0 ? timeData.seconds + 's' : $t('setpwd.sendcode') }}
                                </button>
                            </template>
                        </van-count-down>
                    </div>
                </div>

                <div v-else class="section-block">
                    <label class="field-label">{{ $t('setpaypwd.loginpassword') }}</label>
                    <div class="input-wrap">
                        <input
                            v-model.trim="password"
                            :type="passwordInp"
                            class="text-input"
                            :placeholder="$t('setpaypwd.loginpassword')"
                        >
                        <button type="button" class="eye-btn" @click="showPwd">
                            <van-icon :name="passwordInp === 'password' ? 'closed-eye' : 'eye'" />
                        </button>
                    </div>
                </div>

                <div class="section-block newpwd-block">
                    <label class="field-label">{{ $t('setpaypwd.newpassword') }}</label>
                    <button type="button" class="pwd-trigger" @click="showWord(1)">
                        <span v-if="npassword">{{ maskPayPwd(npassword) }}</span>
                        <span v-else class="placeholder">{{ $t('setpaypwd.newpassword') }}</span>
                        <van-icon :name="newpasswordInp === 'password' ? 'closed-eye' : 'eye'" class="eye-icon" @click.stop="showNewsPwd" />
                    </button>

                    <label class="field-label confirm-label">{{ $t('setpwd.confirmnewpassword') }}</label>
                    <button type="button" class="pwd-trigger" @click="showWord(2)">
                        <span v-if="rpassword">{{ maskPayPwd(rpassword) }}</span>
                        <span v-else class="placeholder">{{ $t('setpwd.confirmnewpassword') }}</span>
                        <van-icon :name="newpasswordInp === 'password' ? 'closed-eye' : 'eye'" class="eye-icon" @click.stop="showNewsPwd" />
                    </button>
                </div>
            </section>

            <button
                v-if="codeStatus"
                type="button"
                class="submit-btn"
                :class="{ disabled: !rpassword || !code || !npassword }"
                @click="dxRevise"
            >
                {{ $t('setpwd.modify') }}
            </button>
            <button
                v-else
                type="button"
                class="submit-btn"
                :class="{ disabled: !password || !rpassword || !npassword }"
                @click="oldRevise"
            >
                {{ $t('setpwd.modify') }}
            </button>
        </main>

        <van-popup v-model="write_psd" round position="bottom" class="paypwd-popup">
            <div class="psw-box">
                <div class="psw-header">{{ $t('setpaypwd.setNewPaymentPassword') }}</div>
                <van-password-input
                    :value="psd_val"
                    :mask="newpasswordInp === 'password'"
                    :focused="showKeyboard"
                    @focus="showKeyboard = true"
                />
                <div class="keyboard-box">
                    <div class="keyboard">
                        <button type="button" class="key-item" v-for="i in 9" :key="i" @click="onInput(i)">
                            <div class="key-inner">{{ i }}</div>
                        </button>
                        <button type="button" class="key-item no-bg" @click="write_psd = false">
                            <div class="key-inner">{{ $t('utils.cancel') }}</div>
                        </button>
                        <button type="button" class="key-item" @click="onInput(0)">
                            <div class="key-inner">0</div>
                        </button>
                        <button type="button" class="key-item no-bg x" @click="onDelete">
                            <van-icon name="delete" />
                        </button>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import Vue from "vue";
import { CountDown, Popup, PasswordInput, NumberKeyboard, Icon, Toast } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(PasswordInput).use(NumberKeyboard).use(Popup).use(CountDown).use(Icon).use(Toast);

export default {
    name: "setpaypwd",
    data() {
        return {
            showKeyboard: true,
            write_psd: false,
            time: 0,
            password: "",
            rpassword: "",
            npassword: "",
            mobile: "",
            ycmobile: "",
            passwordInp: "password",
            newpasswordInp: "password",
            codeStatus: true,
            psd_val: "",
            code: "",
            is_send: false,
            nowInput: 1,
            appOriginalStyles: null,
            bodyOriginalBackground: "",
        };
    },
    created() {
        this.$parent.footer("user", false);
    },
    mounted() {
        this.applyFullScreenLayout();
        Fetch("/user/info").then((r) => {
            this.mobile = (r.data && r.data.mobile) || "";
            this.ycmobile = this.mobile ? this.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2") : "";
        });
    },
    beforeDestroy() {
        this.restoreFullScreenLayout();
    },
    methods: {
        getLabel(key, defaultText) {
            return this.$te(key) ? this.$t(key) : defaultText;
        },
        applyFullScreenLayout() {
            const app = document.getElementById("app");
            if (!app) {
                return;
            }
            this.appOriginalStyles = {
                maxWidth: app.style.maxWidth,
                width: app.style.width,
                margin: app.style.margin,
                backgroundColor: app.style.backgroundColor,
                paddingBottom: app.style.paddingBottom,
            };
            this.bodyOriginalBackground = document.body.style.background;
            app.style.maxWidth = "100%";
            app.style.width = "100%";
            app.style.margin = "0";
            app.style.backgroundColor = "#000000";
            app.style.paddingBottom = "0";
            document.body.style.background = "#000000";
        },
        restoreFullScreenLayout() {
            const app = document.getElementById("app");
            if (app && this.appOriginalStyles) {
                app.style.maxWidth = this.appOriginalStyles.maxWidth || "";
                app.style.width = this.appOriginalStyles.width || "";
                app.style.margin = this.appOriginalStyles.margin || "";
                app.style.backgroundColor = this.appOriginalStyles.backgroundColor || "";
                app.style.paddingBottom = this.appOriginalStyles.paddingBottom || "";
            }
            document.body.style.background = this.bodyOriginalBackground || "";
        },
        maskPayPwd(value) {
            if (this.newpasswordInp === "password") {
                return "•".repeat(value.length);
            }
            return value;
        },
        showWord(n) {
            this.nowInput = n === 1 ? 1 : 2;
            this.psd_val = "";
            this.write_psd = true;
        },
        onInput(key) {
            this.psd_val = (this.psd_val + key).slice(0, 6);
            if (this.psd_val.length === 6) {
                if (this.nowInput === 1) {
                    this.npassword = this.psd_val;
                } else {
                    this.rpassword = this.psd_val;
                }
                setTimeout(() => {
                    this.write_psd = false;
                }, 200);
            }
        },
        onDelete() {
            this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
        },
        cutType(n) {
            this.codeStatus = n === 1;
            this.rpassword = "";
            this.npassword = "";
            this.password = "";
            this.code = "";
        },
        timeCall() {
            this.is_send = false;
            this.time = 0;
        },
        sendcode() {
            if (this.is_send) {
                return;
            }
            this.is_send = true;
            Fetch("/index/register_code", {
                mobile: this.mobile,
            }).then(() => {
                this.time = 60 * 1000;
                this.$toast({
                    className: "toastName",
                    message: this.$t("setpwd.sendsuccessfully"),
                });
            }).catch(() => {
                this.is_send = false;
            });
        },
        showPwd() {
            this.passwordInp = this.passwordInp === "password" ? "text" : "password";
        },
        showNewsPwd() {
            this.newpasswordInp = this.newpasswordInp === "password" ? "text" : "password";
        },
        dxRevise() {
            if (!this.npassword) {
                this.$toast(this.$t("setpaypwd.newpasswordcannotbeempty"));
                return false;
            }
            if (this.npassword !== this.rpassword) {
                this.$toast(this.$t("setpaypwd.inconsistent"));
                return false;
            }
            Fetch("/user/resetpaypwd_code", {
                code: this.code,
                npassword: this.npassword,
            }).then(() => {
                this.$toast({
                    className: "toastName",
                    message: this.$t("setpwd.modifiedsuccessfully"),
                });
                sessionStorage.setItem("pwd", this.npassword);
                if (this.$route.query.redirect) {
                    this.$router.replace(this.$route.query.redirect + "?change");
                } else {
                    this.$router.replace("/safe");
                }
            });
        },
        oldRevise() {
            if (!this.password) {
                this.$toast(this.$t("setpaypwd.loginpasswordcannotbeempty"));
                return false;
            }
            if (!this.npassword) {
                this.$toast(this.$t("setpaypwd.newpasswordcannotbeempty"));
                return false;
            }
            if (this.npassword !== this.rpassword) {
                this.$toast(this.$t("setpaypwd.inconsistent"));
                return false;
            }
            const reg = new RegExp("^[0-9]*$");
            if (!reg.test(this.npassword) || !reg.test(this.rpassword)) {
                this.$toast(this.$t("setpaypwd.pureNumber"));
                return false;
            }
            Fetch("/user/resetpaypwd", {
                passwd: this.password,
                npasswd: this.npassword,
            }).then(() => {
                this.$toast({
                    className: "toastName",
                    message: this.$t("setpwd.modifiedsuccessfully"),
                });
                this.$router.replace("/safe");
            });
        },
    },
};
</script>

<style lang="less" scoped>
.setpaypwd-page {
    min-height: 100vh;
    background: #000;
    color: #fff;
}

.top-nav {
    position: sticky;
    top: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 0 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(12px);
}

.back-btn {
    position: absolute;
    left: 16px;
    top: 50%;
    width: 28px;
    height: 28px;
    margin-top: -14px;
    border: 0;
    background: transparent;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn .van-icon {
    font-size: 22px;
}

.nav-title {
    font-size: 18px;
    font-weight: 700;
}

.page-content {
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 24px 14px 30px;
    box-sizing: border-box;
}

.form-card {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(12px);
    padding: 22px 18px;
    margin-bottom: 18px;
}

.card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 22px;
}

.card-header h1 {
    margin: 0 0 8px;
    font-size: 24px;
    font-weight: 800;
    color: #fff;
}

.card-header p {
    margin: 0;
    color: rgba(255, 255, 255, 0.52);
    font-size: 12px;
    line-height: 1.7;
}

.switch-mode {
    min-width: 104px;
    height: 34px;
    padding: 0 12px;
    border: 0;
    border-radius: 10px;
    background: rgba(45, 91, 255, 0.12);
    color: #2d5bff;
    font-size: 12px;
    font-weight: 700;
    flex-shrink: 0;
}

.section-block + .section-block {
    margin-top: 18px;
    padding-top: 18px;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.field-label {
    display: block;
    margin: 0 0 10px 2px;
    color: rgba(255, 255, 255, 0.88);
    font-size: 14px;
}

.info-box,
.input-wrap,
.code-wrap,
.pwd-trigger {
    min-height: 54px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.02);
}

.info-box {
    display: flex;
    align-items: center;
    padding: 0 16px;
    color: #2d5bff;
    font-size: 15px;
    font-weight: 700;
}

.input-wrap,
.code-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 12px 0 16px;
}

.newpwd-block .confirm-label {
    margin-top: 14px;
}

.text-input {
    flex: 1;
    min-width: 0;
    height: 100%;
    border: 0;
    outline: none;
    background: transparent;
    color: #fff;
    font-size: 15px;
}

.text-input::placeholder {
    color: rgba(255, 255, 255, 0.28);
}

.eye-btn,
.code-btn {
    border: 0;
    background: transparent;
    flex-shrink: 0;
}

.eye-btn {
    width: 34px;
    height: 34px;
    color: rgba(255, 255, 255, 0.54);
    display: flex;
    align-items: center;
    justify-content: center;
}

.eye-btn .van-icon {
    font-size: 20px;
}

.countdown {
    flex-shrink: 0;
}

.code-btn {
    min-width: 98px;
    height: 38px;
    padding: 0 12px;
    border-radius: 10px;
    background: rgba(45, 91, 255, 0.12);
    color: #2d5bff;
    font-size: 13px;
    font-weight: 700;
}

.code-btn[disabled] {
    opacity: 0.6;
}

.pwd-trigger {
    width: 100%;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    color: #fff;
    font-size: 15px;
    text-align: left;
}

.placeholder {
    color: rgba(255, 255, 255, 0.28);
}

.eye-icon {
    flex-shrink: 0;
    color: rgba(255, 255, 255, 0.54);
    font-size: 20px;
}

.submit-btn {
    width: 100%;
    height: 48px;
    border: 0;
    border-radius: 12px;
    background: linear-gradient(135deg, #2d5bff 0%, #104af0 100%);
    box-shadow: 0 4px 15px rgba(45, 91, 255, 0.3);
    color: #fff;
    font-size: 15px;
    font-weight: 700;
}

.submit-btn.disabled {
    opacity: 0.55;
}

.paypwd-popup {
    background: transparent;
}

.psw-box {
    padding: 18px 12px 28px;
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
    background: #0b0f1f;
}

.psw-header {
    padding-bottom: 18px;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
}

:deep(.van-password-input) {
    margin: 6px 6px 26px;
}

:deep(.van-password-input__security) {
    height: 52px;
    background: transparent;
}

:deep(.van-password-input__security li) {
    margin: 0 4px;
    border: 1px solid rgba(45, 91, 255, 0.28);
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.04);
    color: #fff;
    font-size: 24px;
}

:deep(.van-password-input__security::after) {
    display: none;
}

.keyboard-box {
    padding: 0 2px;
}

.keyboard {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 8px 0;
}

.key-item {
    width: 32%;
    height: 50px;
    border: 0;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.06);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.key-inner {
    font-size: 22px;
    font-weight: 700;
}

.key-item.no-bg {
    background: rgba(255, 255, 255, 0.02);
}

.key-item.no-bg .key-inner {
    font-size: 15px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.72);
}

.key-item.x {
    color: rgba(255, 255, 255, 0.82);
    font-size: 22px;
}
</style>
